import styled from 'styled-components'
import { CSS } from 'ui/helpers'

export const HighlightStatus = styled.span`
  color: ${(p) => p.theme.uiKit.colors.theme.negative.main};
  ${(p) => CSS.populateFont(p.theme.uiKit.typography.bodyM.semiBold)};
`
